import type { Transaction } from "features/transactions/types";
import {
    BooleanStatus,
    SettlementStatus,
    TransactionFundStatus,
    TransactionStatus
} from "ui/molecules/Status";
import { Column, type ColumnDef, type ColumnGetter } from "./types";

export const useColumns = () => {
    const getColumn = (column: ReturnType<ColumnGetter<keyof Transaction>>) => ({
        ...new Map<string, ColumnDef>()
            .set(Column.RefId, {
                headerName: 'Reference ID'
            })
            .set(Column.SettledDate, {
                headerName: 'Setteled Date'
            })
            .set(Column.CreatedAt, {
                headerName: 'Created At'
            })
            .set(Column.LocalTime, {
                headerName: 'Date Local'
            })
            .set(Column.IsSettled, {
                headerName: 'Setteled',
                component: BooleanStatus
            })
            .set(Column.SettlementStatusDateTime, {
                headerName: 'CSV Fund Status Date'
            })
            .set(Column.SettlementStatus, {
                headerName: 'CSV Fund Status',
                component: SettlementStatus
            })
            .set(Column.FundStatus, {
                headerName: 'Funds Status',
                component: TransactionFundStatus
            })
            .set(Column.Status, {
                headerName: 'Status',
                component: TransactionStatus
            })
            .set(Column.UpdatedAt, {
                headerName: 'Date Updated'
            })
            .get(column.field),
        ...column
    });

    const withColumns = (columns: Array<Parameters<typeof getColumn>[0]>) => (
        Array.from(
            columns
                .reduce((map, column) => (
                    map.set(column.field, column)
                ), new Map()),
            ([, column]) => getColumn(column)
        )
    );

    return {
        withColumns
    };
};

export default useColumns;
